import { debounce } from "lodash";

import formatElementTypeAndValue from "./formatElementTypeAndValue";

/**
 * Debounced version of the analytics tracking function for text inputs
 * Only sends the event after user stops typing for the specified delay
 */
const debouncedTrackElementChange = debounce(
  ({ element_type, element_value }) => {
    if (window[process.env.REACT_APP_ANALYTICS_FUNCTION]) {
      window[process.env.REACT_APP_ANALYTICS_FUNCTION].push({
        event: "custom_element_change",
        element_type,
        element_value,
        timestamp: Date.now(),
      });
    } else {
      console.warn("Analytics function not defined");
    }
  },
  2000
); // Wait 2000ms after typing stops before firing the event

/**
 * Tracks when a user changes a customisation value
 * @param {Object} params - The parameters object
 * @param {string} params.elementType - The type of element that changed (e.g., 'blade_pattern', 'stick_flex', etc.)
 * @param {string|number|boolean} params.elementValue - The new value of the element
 * @param {boolean} params.debounce - Whether this input should be debounced
 */
const trackElementChange = ({
  elementType,
  elementValue,
  debounce = false,
}) => {
  if (elementType === undefined || elementValue === undefined) {
    return;
  }

  const { element_type, element_value } = formatElementTypeAndValue({
    elementType,
    elementValue,
  });

  if (debounce) {
    debouncedTrackElementChange({ element_type, element_value });
  } else if (window[process.env.REACT_APP_ANALYTICS_FUNCTION]) {
    window[process.env.REACT_APP_ANALYTICS_FUNCTION].push({
      event: "custom_element_change",
      element_type,
      element_value,
      timestamp: Date.now(),
    });
  } else {
    console.warn("Analytics function not defined");
  }
};

export default trackElementChange;
